export const environment = {
  production: true,
  apiBaseUrl: 'https://goul.org/api',
  appVersion: '4.0.0',
};
